import { SidePanelPageLayoutTsoPq } from '@components/Grid/GridTsoPq';
import PqIndexApplyedParameters from './Sections/PqIndexApplyedParameters';
import PqIndexParameters from './Sections/PqIndexParameters';

const PqIndex = () => {
  return <SidePanelPageLayoutTsoPq sidePanel={<PqIndexParameters />} content={<PqIndexApplyedParameters />} />;
};

export default PqIndex;
